<template>
    <div class="main">
        <div class="change-box">
            <div class="box fl">
                <div class="input-box">
                    <p class="label fl">所属分类</p>
                    <select class="input fl" v-model="type">
                        <option v-for="item in typeList" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
                <div class="input-box">
                    <p class="label fl">销售价(元)</p>
                    <input class="input fl" v-model="price"/>
                </div>
            </div>
            <div class="box fl">
                <div class="input-box">
                    <p class="label fl">供货价</p>
                    <p class="input fl" v-text="(goodInfo.jdDisPrice / 100).toFixed(2)"></p>
                </div>
                <div class="input-box">
                    <p class="label fl">园区币价</p>
                    <input class="input fl" v-model="cbPrice">
                </div>
            </div>
            <button class="submit fr" @click="submit()">
                <span v-if="pageType === 'add'">添加</span>
                <span v-if="pageType === 'edit'">保存</span>
            </button>
        </div>
        <div class="main-imgs-box">
            <h1 class="title">添加预览主图</h1>
            <ul>
                <li class="add-image-btn">
                    <input class="file-input" type="file" accept="image/*" @change="chooseMainImg">
                </li>
                <li class="img-box" v-for="(img , index) in briefImage" :key="index">
                    <img :src="img.localUrl || img.link">
                    <img class="dept-delete-icon" src="@/assets/shop/delete-icon-c.png" @click="deleteImg('briefImage', index)">
                </li>
                <li class="clear"></li>
            </ul>
        </div>
        <div class="detail-imgs-box">
            <h1 class="title">添加商品详情图</h1>
            <ul>
                <li class="add-image-btn">
                    <input class="file-input" type="file" accept="image/*" @change="chooseDetailImg">
                </li>
                <li class="img-box" v-for="(img , index) in particularImage" :key="index">
                    <img :src="img.localUrl || img.link">
                    <img class="dept-delete-icon" src="@/assets/shop/delete-icon-c.png" @click="deleteImg('particularImage', index)">
                </li>
                <li class="clear"></li>
            </ul>
        </div>

        <div class="detaile-box">
            <ul>
                <li  v-for="(img, index) in particularImage" :key="index">
                    <img :src="img.localUrl || img.link">
                </li>
            </ul>
            <!--<div v-html="goodInfo.introduction"></div>-->
        </div>
    </div>
</template>

<script>
  import {getGoodInfo, addGood, editGoodInfo} from '@/api/shop'
  import {getAuthFunction} from '@/api/cos'
  import {goodFileBucket, goodFileRegion, fileFloder, cdnUrl} from "@/config";
  import DdbesCos from '@/utils/ddbesCos'
  import COS from 'cos-js-sdk-v5'
  import {getGstore} from '@/utils/storage'

  export default {
    name: "addGood",
    data() {
      return {
        goodInfo: {},
        type: '手机',
        pageType: 'add',
        price: '',
        cbPrice: '',
        typeList: ['手机', '文件管理', '桌面文具', '办公设备', '电脑数码'],
        cos: {},
        briefImage: [],
        particularImage: [],
      }
    },
    mounted() {
      const {id, skuId} = this.$route.query;
      if (skuId) {
        this.pageType = 'add';
        this.getGoodInfo(skuId + '', 2)
      } else if (id) {
        this.pageType = 'edit';
        this.getGoodInfo(id + '', 1)
      }
      const userStr = getGstore('loginData');
      if(userStr){
        const userData =  JSON.parse(userStr);
        this.cos = new DdbesCos({
          getAuthorization: getAuthFunction,
          defaultRegion: goodFileRegion,
          defaultBucket: goodFileBucket,
          uuid: userData.userId
        }, COS);
      }

    },
    methods: {
      chooseMainImg(e){
        if(e.target.files.lenght +this.briefImage.length > 5 ){
          return this.$message({
            type:'error',
            message: '最多只能上传5张图片'
          })
        }
        this.uploadImg(e.target.files, 'briefImage')
      },

      uploadImg(files, type){
        files.forEach((file)=>{
          let key = this.getFileKey();
          const loaclUrl = this.getObjectURL(file);
          this[type].push({
            key: key,
            localUrl: loaclUrl,
            status: 'loading'
          });
          this.cos.sliceUploadFile({
            key: key,
            file:file
          },(err, data) => {
            if(data){
              const index = this[type].findIndex((item)=>{
                return item.key === key;
              });
              this.$set(this[type][index], 'status', 'over');
              this.$set(this[type][index], 'link', cdnUrl + key)
              console.log(this[type])
            }
          })
        })
      },
      deleteImg(type, index){
        this[type].splice(index, 1);
      },
      chooseDetailImg(e){
        if(e.target.files.lenght +this.particularImage.length > 10 ){
          return this.$message({
            type:'error',
            message: '最多只能上传10张图片'
          })
        }
        this.uploadImg(e.target.files, 'particularImage')
      },
      getObjectURL(file) {
        let url = null ;
        if (window.createObjectURL) { // basic
          url = window.createObjectURL(file) ;
        } else if (window.URL) { // mozilla(firefox)
          url = window.URL.createObjectURL(file) ;
        } else if (window.webkitURL) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file) ;
        }
        return url ;
      },
      getFileKey(){
        const time = new Date().getTime();
        const random = Math.random().toString(36).slice(-8);
        return '/' + fileFloder + '/' + time + random
      },
      rebuildPrice(price, num) {
        return (price / num).toFixed(2)
      },
      getGoodInfo(id, type) {
        getGoodInfo({
          id: id,
          type: type,
        }).then((res) => {
          this.goodInfo = res.data;
          console.log('-------------------')
          console.log(this.goodInfo)
          if(this.goodInfo.category){
            this.type = this.goodInfo.category
          }
          this.briefImage = this.goodInfo.briefImage.map(item => {
           return {link: item}
          })
          this.particularImage = this.goodInfo.particularImage.map(item => {
            return {link: item}
          })

          if(this.pageType === 'add'){
            this.price = this.rebuildPrice(this.goodInfo.jdDisPrice, 100)
            this.cbPrice = this.rebuildPrice(this.goodInfo.jdDisPrice, 100)
          } else {
            this.price = this.rebuildPrice(this.goodInfo.price, 100)
            this.cbPrice = this.rebuildPrice(this.goodInfo.rpPrice, 100)
          }
        })
      },

      submit() {
        if (this.pageType === 'add') {
          this.addNewGood();
        } else if (this.pageType === 'edit') {
          this.editGood()
        }
      },

      editGood() {
        if(!this.checkMainImg()){
          return
        }
        editGoodInfo({
          "category": this.type,
          "id": this.goodInfo.id,
          "price": this.price * 100,
          "rpPrice": this.cbPrice * 100,
          "briefImage": this.briefImage.map((item)=> item.link),
          "particularImage": this.particularImage.map((item)=> item.link)
        }).then((res) => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          setTimeout(()=>{
            this.$router.back();
          }, 1000)
        })

      },

      checkMainImg(){
        if(this.briefImage.length === 0){
          this.$message({
            type:'error',
            message: '请至少添加一张图片'
          })
          return false
        }
        return true
      },

      addNewGood() {
        if(!this.checkMainImg()){
          return
        }
        addGood({
          "category": this.type,
          "goodsName": this.goodInfo.name,
          "rmbPrice": this.price * 100,
          "rpPrice": this.cbPrice * 100,
          "skuId": this.goodInfo.sid,
          "briefImage": this.briefImage.map((item)=> item.link),
          "particularImage": this.particularImage.map((item)=> item.link)
        }).then((res) => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          setTimeout(()=>{
            this.$router.back();
          }, 1000)
        })
      }

    }
  }
</script>

<style scoped lang="scss">
    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .main {
        min-width: 900px;
        margin: 0 40px;
        background: #FFFFFF;

        .change-box {
            height: 180px;
            padding: 10px;
            box-sizing: border-box;

            .box {
                margin-left: 30px;
            }

            .submit {
                cursor: pointer;
                margin-top: 30px;
                margin-right: 30px;
                background: #5189F7;
                color: #FFFFFF;
                font-size: 14px;
                border-radius: 6px;
                border: none;
                outline: none;
                height: 35px;
                width: 116px;
            }

            .input-box {
                height: 40px;
                margin-top: 30px;

                .label {
                    width: 80px;
                    color: #333333;
                    font-size: 14px;
                    line-height: 40px;
                }

                .input {
                    line-height: 40px;
                    padding-left: 11px;
                    height: 40px;
                    width: 300px;
                    font-size: 14px;
                    border-radius: 5px;
                    border: solid #E4E4E4 1px;
                    box-sizing: border-box;
                }
            }
        }

        .detaile-box {
            margin: auto;
            max-width: 320px;
            overflow: auto;
            height: calc(100vh - 300px);
            img{
                width: 100%;
            }
        }
    }

    .title{
        font-size: 16px;
        margin-bottom: 20px;
    }

    .main-imgs-box{
        padding: 20px 40px;

    }
    .detail-imgs-box{
        padding: 20px 40px;
    }
    .add-image-btn{
        position: relative;
        width: 52px;
        height: 52px;
        cursor: pointer;
        background: url('~@/assets/images/add-image.png') no-repeat center / 100%;
        .file-input{
            cursor: pointer;
            position: absolute;
            opacity: 0;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
        }
    }
    .img-box{
        position: relative;
        float: left;
        width: 52px;
        height: 52px;
        margin-top: 10px;
        margin-right: 10px;
        img{
            height: 100%;
            width: 100%;
        }
        .dept-delete-icon{
            position: absolute;
            right: -10px;
            top: -3px;
            height: 14px;
            width: 14px;
            display: none;;
        }
        &:hover{
            .dept-delete-icon{
                cursor: pointer;
                display: block;
            }
        }
    }
    .clear{
        clear: both;
    }
</style>
